module.exports = __webpack_public_path__ + "static/media/statistics.116d4ad4.svg";